var DevOps = "DevOps";
var Gaming = "เกม";
var Migration = "การโยกย้าย";
var Other = "อื่นๆ";
var useCase = {
	"Use case": "กรณีการใช้งาน",
	"AI & machine learning": "AI และแมชชีนเลิร์นนิง",
	"Batch processing": "การประมวลผลชุดงาน",
	"Big data, analytics, & business intelligence": "Big data การวิเคราะห์ และระบบธุรกิจอัจฉริยะ",
	"Business applications - Microsoft": "การใช้งานทางธุรกิจ - Microsoft",
	"Business applications - Oracle": "การใช้งานทางธุรกิจ - Oracle",
	"Business applications - Other": "การใช้งานทางธุรกิจ - อื่นๆ",
	"Business applications - SAP": "การใช้งานทางธุรกิจ - SAP",
	"Content delivery": "การส่งมอบเนื้อหา",
	DevOps: DevOps,
	Gaming: Gaming,
	"Internet of things": "อินเทอร์เน็ตในทุกสิ่ง",
	"Learning & certification": "การฝึกอบรมและใบรับรอง",
	"Media services": "บริการสื่อ",
	Migration: Migration,
	"Mobile applications": "แอปพลิเคชันบนมือถือ",
	Other: Other,
	"Storage & backup": "ที่เก็บข้อมูลและการสำรองข้อมูล",
	"Websites & web apps": "เว็บไซต์และเว็บแอป"
};

export { DevOps, Gaming, Migration, Other, useCase as default };
